/**
 * Converts a `DayOfWeek` to a human readable name
 */
export const DowNameEnum = {
    M: 'Monday',
    T: 'Tuesday',
    W: 'Wednesday',
    Th: 'Thursday',
    F: 'Friday',
    S: 'Saturday',
    Su: 'Sunday',
};
/**
 * Converts a `DayOfWeek` to a 3-letter abbreviation.
 */
export const DowAbbrevEnum = {
    M: 'Mon',
    T: 'Tue',
    W: 'Wed',
    Th: 'Thu',
    F: 'Fri',
    S: 'Sat',
    Su: 'Sun',
};
/**
 * Converts a `DayOfWeek` into a numerical value (Range 0-6 inclusive)
 */
export const DayToNum = {
    Su: 0,
    M: 1,
    T: 2,
    W: 3,
    Th: 4,
    F: 5,
    S: 6,
};
/**
 * Converts a numerical value (Range 0-6 inclusive) to a `DayOfWeek`
 */
export const NumToDay = {
    0: 'Su',
    1: 'M',
    2: 'T',
    3: 'W',
    4: 'Th',
    5: 'F',
    6: 'S',
};
/**
 * Converts a `DayOfWeek` to a object containing the following:
 *  - `value`: The `DayOfWeek` itself.
 *  - `name`: See `DowNameEnum`.
 *  - `abbrevName`: See `DowAbbrevEnum`.
 *
 */
export const DaysOfWeek = {
    M: {
        value: 'M',
        name: DowNameEnum.M,
        abbrevName: DowAbbrevEnum.M,
    },
    T: {
        value: 'T',
        name: DowNameEnum.T,
        abbrevName: DowAbbrevEnum.T,
    },
    W: {
        value: 'W',
        name: DowNameEnum.W,
        abbrevName: DowAbbrevEnum.W,
    },
    Th: {
        value: 'Th',
        name: DowNameEnum.Th,
        abbrevName: DowAbbrevEnum.Th,
    },
    F: {
        value: 'F',
        name: DowNameEnum.F,
        abbrevName: DowAbbrevEnum.F,
    },
    S: {
        value: 'S',
        name: DowNameEnum.S,
        abbrevName: DowAbbrevEnum.S,
    },
    Su: {
        value: 'Su',
        name: DowNameEnum.Su,
        abbrevName: DowAbbrevEnum.Su,
    },
};
